import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { ICauHinhHeThong } from 'src/types/CauHinhHeThong.type';
import { setCauHinhHeThong } from './CauHinhHeThong.slice';

export default function useCauHinhHeThong() {
  const dispatch = useDispatch();
  const cauHinh = useAppSelector((state) => state.cauHinhHeThong);

  const datCauHinh = (cauHinh: ICauHinhHeThong[]) => {
    dispatch(setCauHinhHeThong(cauHinh));
  };

  const clear = () => {
    datCauHinh([]);
  };

  const cauHinhObj: { [key: string]: string } = useMemo(() => {
    const obj: { [key: string]: string } = {};
    cauHinh.forEach((item) => {
      obj[item.MaCauHinh] = item.GiaTri;
    });
    return obj;
  }, [cauHinh]);

  return {
    cauHinh,
    datCauHinh,
    clear,
    cauHinhObj,
  };
}
